export default __webpack_public_path__ + "6b20e7a000eade0080b14916205a7a3f.svg";